/** Captures `beforeinstallprompt` as early as possible so React mount cannot miss it. */

export type BeforeInstallPromptEvent = Event & {
  prompt: () => Promise<void>
  userChoice: Promise<{ outcome: 'accepted' | 'dismissed'; platform: string }>
}

type Listener = (event: BeforeInstallPromptEvent | null) => void

let deferred: BeforeInstallPromptEvent | null = null
const listeners = new Set<Listener>()

function notify(event: BeforeInstallPromptEvent | null) {
  listeners.forEach((listener) => listener(event))
}

if (typeof window !== 'undefined') {
  window.addEventListener('beforeinstallprompt', (e) => {
    e.preventDefault()
    deferred = e as BeforeInstallPromptEvent
    notify(deferred)
  })
}

export function getDeferredInstallPrompt(): BeforeInstallPromptEvent | null {
  return deferred
}

export function clearDeferredInstallPrompt(): void {
  deferred = null
  notify(null)
}

export function subscribeDeferredInstallPrompt(listener: Listener): () => void {
  listeners.add(listener)
  if (deferred) listener(deferred)
  return () => {
    listeners.delete(listener)
  }
}
